import React, { Component } from 'react';
import styled from 'styled-components';
import { getTheme } from '../../global/utils';
import ReactTooltip from 'react-tooltip';

const TooltipWrapper = styled.div`
  .__react_component_tooltip {
    border-radius: ${getTheme('radius', 'm')};
    background-color: ${getTheme('black', '_100')};
    font-size: ${getTheme('fontSize', 'note')};
    color: ${getTheme('textColor', 'baseLight')};
    padding: ${getTheme('padding', 'verticalM')} ${getTheme('padding', 'horizontalM')};
    &.place-top {
      margin-top: 0;
    }
    &.place-bottom {
      margin-bottom: 0;
    }
  }
  .__react_component_tooltip.type-dark {
    background-color: ${getTheme('black', '_100')};
  }
  .__react_component_tooltip.type-dark.place-top::after {
    border-top-color: ${getTheme('black', '_100')};
    border-top-width: 10px;
  }
  .__react_component_tooltip.type-dark.place-bottom::after {
    border-bottom-color: ${getTheme('black', '_100')};
    border-bottom-width: 10px;
  }
  .__react_component_tooltip.type-dark.place-left::after {
    border-left-color: ${getTheme('black', '_100')};
    border-left-width: 10px;
  }
  .__react_component_tooltip.type-dark.place-right::after {
    border-right-color: ${getTheme('black', '_100')};
    border-right-width: 10px;
  }
`;

class Tooltip extends Component {
  render() {
    return (
      <TooltipWrapper>
        <ReactTooltip effect="solid" />
      </TooltipWrapper>
    );
  }
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/tooltip/Tooltip.js